<template>
  <div>
    <el-button icon="el-icon-notebook-2" @click="openTitleBox">选择标题</el-button>
    <span style="margin-left: 10px">{{ titleData.list.length }}/{{ limit }}</span>
    <el-link
      v-if="titleData.list.length"
      style="float: right"
      type="primary"
      @click="titleData.list = []"
    >清空</el-link>
    <div v-if="titleData.list.length" class="title-list">
      <div class="title-list-box">
        <div
          v-for="(item, index) in titleData.list"
          :key="index"
          class="title-item"
        >
          <span>{{ item.name }}</span>

          <span class="title-edit">
            <el-popover v-model="item.is_title_pop" placement="right" width="400">
              <div style="width: 300px;display: inline-block;">
                <el-input v-model="title_name" />
              </div>
              <span>
                {{ getStrLen(title_name) }} /
                <span :style="{color: getStrLen(title_name) > 30 ? '#f45858' : 'inherit'}">30</span>
              </span>
              <div style="padding: 10px 0">
                插入动态词包：
                <el-link
                  :underline="false"
                  @click="title_name += '{地点}'"
                >
                  +地点
                </el-link>
                <el-link
                  :underline="false"
                  @click="title_name += '{年龄}'"
                >
                  +年龄
                </el-link>
                <el-link
                  :underline="false"
                  @click="title_name += '{日期}'"
                >
                  +日期
                </el-link>
                <el-link
                  :underline="false"
                  @click="title_name += '{星期}'"
                >
                  +星期
                </el-link>
              </div>
              <div>
                <el-button type="text" size="mini" @click.stop="item.is_title_pop = false">取消</el-button>
                <el-button type="primary" size="mini" @click.stop="alterTitle(item, title_name)">确定</el-button>
              </div>
              <i slot="reference" class="el-icon-edit" @click.stop="title_name = item.name" />
            </el-popover>
            <i class="el-icon-close" @click="delectTitle(index)" />
          </span>

        </div>
      </div>
    </div>

    <title-material
      v-if="is_open"
      :is-open="is_open"
      advertiser-type="jrtt"
      :min-length="5"
      :max-length="30"
      @confirm="titleBoxConfirm"
      @cancel="titleBoxCancel"
    />
  </div>
</template>

<script>
export default {
  components: {
    'title-material': () => import('./title-material.vue'),
  },
  props: {
    // 标题数据
    titleData: {
      type: Object,
      required: true,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      title_name: '',
      is_open: false,
    };
  },
  methods: {
    /**
     * 选择标题
     */
    openTitleBox() {
      this.is_open = true;
    },

    /**
     * 修改标题
     * @param title_item 标题项
     * @param str 修改字符串
     */
    alterTitle(title_item, str) {
      const str_len = this.getStrLen(str);
      if (str_len >= 5 && str_len <= 30) {
        title_item.name = str;
        title_item.is_title_pop = false;
      } else {
        this.$message({
          showClose: true,
          message: '标题5到30个字，请正确输入',
          type: 'error',
        });
      }
    },

    /**
     * 标题框确定
     */
    titleBoxConfirm(data) {
      this.is_open = false;
      if ((this.titleData.list.length + data.length) > this.limit) {
        this.$message.warning(`标题素材不能超过${this.limit}个！`);
        return;
      }

      this.titleData.list = this.unique(this.titleData.list.concat(data), 'name');
    },

    /**
     * 标题框取消
     */
    titleBoxCancel() {
      this.is_open = false;
    },

    /**
     * 删除标题
     * @param {number} index
     */
    delectTitle: function(index) {
      this.titleData.list.splice(index, 1);
    },

    /**
     * 去重
     * @param {Array<any>} arr 数组
     * @param {string} key 键值
     */
    unique: function(arr, key) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr[key]) && res.set(arr[key], 1));
    },

    /**
     * 获取字符位数
     * @param {string} str 字符串
     */
    getStrLen: function(str) {
      var realLength = 0,
        len = str.length,
        charCode = -1;
      for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128) {
          realLength += 1;
        } else {
          realLength += 2;
        }
      }
      return Math.ceil(realLength / 2);
    },
  },
};
</script>

<style lang="scss" scoped>
.title-list {
    margin-top: 20px;
    border: 1px #ccc solid;
    .title-list-box {
      max-height: 300px;
      overflow: auto;
      .title-item {
        padding: 10px;
        background-color: #fff;
        margin-top: 10px;
        cursor: pointer;
        .title-edit {
          float: right;
          color: #1890ff;
          i {
            padding: 0 5px;
          }
        }
        &:hover {
          background-color: #f1f1f1;
        }
        &:nth-child(1) {
          margin-top: 0;
        }
      }
    }
  }
</style>
